import Vue from 'vue';
import Clipboard from 'v-clipboard';
import VModal from 'vue-js-modal';
import PortalVue from 'portal-vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';

Vue.use(Clipboard);
Vue.use(VModal, { componentName: 'mj-modal' });
Vue.use(PortalVue);
Vue.use(VCalendar, {
  firstDayOfWeek: 2,
});
